// removed by extract-text-webpack-plugin
module.exports = {"Hero__top":"src-components-Program-Hero----Hero-module---Hero__top---3Qx23","Hero__title":"src-components-Program-Hero----Hero-module---Hero__title---3KSpH","Hero__strokes":"src-components-Program-Hero----Hero-module---Hero__strokes---2Kymv","Hero__Image":"src-components-Program-Hero----Hero-module---Hero__Image---3eNLf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Program/Hero/Hero.module.scss
// module id = 734
// module chunks = 168707334958949